import { FC, useContext } from "react";
import { Badge } from "@mui/material";
import AppStateContext from "contexts/AppStateContext";
import { useRequisitionStatusUpdateCount } from "hooks/useRequisitions";
import { useInquiryStatusUpdateCount } from "hooks/useInquiryStatusUpdates";
import type { NavBadgeProps } from "dashboard_layout/navigation";

// The Requisitions and Inquiries menu badges. Neither counts "created since
// I last looked" against a timestamp in local storage, the way the old
// Inquiries badge did: a row's news is a change that reached it from the
// other side (the Inquiry moved the requisition; the requester moved the
// Inquiry), and that is already a flag on the row that opening it clears for
// everyone. So each badge is simply how many rows carry the flag right now -
// the same number of markers the list shows - and it goes down as they are
// opened, on this machine or anyone else's.
//
// `active` is unused on purpose: being on the list page does not read the
// rows, opening them does, and the count follows that through the query
// cache (the acknowledgement invalidates it).
export const RequisitionUpdatesBadge: FC<NavBadgeProps> = () => {
  const { token } = useContext(AppStateContext);
  const { data } = useRequisitionStatusUpdateCount(token);
  return <Badge color="primary" badgeContent={data?.count ?? 0} />;
};

export const InquiryUpdatesBadge: FC<NavBadgeProps> = () => {
  const { token } = useContext(AppStateContext);
  const { data } = useInquiryStatusUpdateCount(token);
  return <Badge color="primary" badgeContent={data?.count ?? 0} />;
};
